import React from "react";
import mascot from "../../../../assets/AIcontainer.png";

const WelcomeScreen = ({ onStartAnalysis, subsection, subsectionUrl }) => {
  
  // Configuration for agent-specific content
  const getAgentContent = () => {
    switch(subsectionUrl) {
      // 1. Strength Agent (Module 1)
      case "strength_agent":
        return {
          title: "Welcome to Strengths Deep Dive",
          description: "Welcome! I'm SiYu, your friendly companion here to help you analyse, probe and grow. Let's embark on this journey of discovering your strengths together!",
          ctaText: "Discover my strengths"
        };
      
      // 2. Vision, Value & Resource Agents
      case "vision_value_agent":
        return {
          title: "Welcome to Deep Dive of vision of next level",
          description: "Welcome! I'm SiYu, your friendly companion here to help you analyse, probe and grow. Let's build what you will do at next level what backs you up.",
          ctaText: "Build My Case"
        };
      
      // 3. What is in your control agent
      case "control_agent":
        return {
          title: "Welcome to Your Promotion Actions Deep Dive",
          description: "Welcome! I'm SiYu, your friendly companion here to help you analyse, probe and grow. Let's get clarity on what's working, what isn't, and what changes next.",
          ctaText: "Start Analysis"
        };
      
      // 3a. Analysis: Your Promotion Process
      case "unfairness_agent":
        return {
          title: "Let's Analyse What was unfair in promotion cycle",
          description: "Today, we'll analyze how promotions function in your organization. Let's uncover What you found unfair",
          ctaText: "Start Analysis"
        };
      
      // 4. Practice: What is in it for me?
      case "visibility_agent":
        return {
          title: "Welcome to the Deep Dive",
          description: "Welcome! I'm SiYu, your friendly companion here to help you analyse, probe and grow. Let's embark on this journey of discovering your strengths together!",
          ctaText: "Let's Do WIIFM"
        };
      
      // 6. Refine your brand
      case "brand_agent":
        return {
          title: "Let's develop your personal brand",
          description: "We'll develop personal brand that can help you get your next level. We'll make your message uniquely yours and backed by evidence.",
          ctaText: "Sharpen My Positioning"
        };
      
      // 7. Refine your pitch
      case "pitch_agent":
        return {
          title: "Let's refine promotion pitch",
          description: "Let's build a promotion pitch that's hard to say no to. We'll make yours promotion pitch, evidence-backed, and hard to push aside.",
          ctaText: "Sharpen My Pitch"
        };
      
      // 7a. Practice scenario of "No"
      case "practicing_pitch_agent":
        return {
          title: "Rehearse Tough Promotion Talks",
          description: "Let's practice for realistic manager pushback and learn how to respond with clarity and composure.",
          ctaText: "Face the Pushback"
        };
      
      // general_reflection_agent (default behavior)
      case "general_reflection_agent":
        return {
          title: "Welcome to the Deep Dive",
          description: "Welcome! I'm SiYu, your friendly companion here to help you analyse, probe and grow. Let's embark on this journey of discovering your strengths together!",
          ctaText: "Start Analysis"
        };
      
      // Default fallback
      default:
        return {
          title: "Welcome to the Deep Dive",
          description: "Welcome! I'm SiYu, your friendly companion here to help you analyse, probe and grow. Let's embark on this journey of discovering your strengths together!",
          ctaText: "Start Analysis"
        };
    }
  };

  const agentContent = getAgentContent();

  return (
    <div className="w-full min-h-[805px] h-full flex flex-col items-center justify-center py-12 px-8 bg-white rounded-[20px]">
      {/* Tiger Character Image */}
      <div className="mb-8 flex-shrink-0">
        <img
          src={mascot}
          alt="SiYu Character"
          className="w-64 h-64 object-contain"
        />
      </div>

      {/* Dynamic Welcome Title */}
      <h1 className="text-[28px] leading-[135%] font-medium text-[#323232] mb-6 text-center max-w-md font-gotham">
        {agentContent.title}
      </h1>

      {/* Dynamic Description Text */}
      <p className="text-base leading-[165%] font-normal text-[#323232] text-center max-w-2xl mb-10 px-4 font-gotham">
        {agentContent.description}
      </p>

      {/* Dynamic CTA Button */}
      <button
        onClick={onStartAnalysis}
        className="flex items-center justify-between bg-[#54B0AF] hover:bg-[#459E9D] text-white font-medium rounded-[20px] px-5 py-[22px] min-w-[280px] transition-all duration-200 shadow-md hover:shadow-lg font-gotham"
      >
        <span className="text-base font-gotham font-medium">{agentContent.ctaText}</span>
        <div className="w-[24px] h-[24px] rounded-full bg-white flex items-center justify-center flex-shrink-0">
          <svg
            className="w-[14px] h-[14px]"
            fill="none"
            stroke="#54B0AF"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </div>
      </button>
    </div>
  );
};

export default WelcomeScreen;

